import React from "react"
import ViewBnOrders from "./ViewBnOrders"
import PickAndPackProvider from "./PickAndPackProvider"

const ScreenBnOrdersSell = () => {
    return <PickAndPackProvider>
        <ViewBnOrders lockedSide="Sell" />
    </PickAndPackProvider>
}

export default ScreenBnOrdersSell